module.exports = __webpack_public_path__ + "static/media/icon-payment-secure-lock.59f8d57e.svg";